












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Checkbox extends Vue {
    @Prop({ default: 'Mailing', required: true }) readonly label!: string
    @Prop() readonly value!: boolean
    @Prop({ default: 'task-checkbox', required: true }) readonly taskId: any

    internalValue: boolean = false

    mounted(): void {
        this.internalValue = this.value
    }
}
